import { fetchCountries } from 'services/api/Locations';
import {
  fetchAnttTypes,
  fetchPaymentMethods,
  fetchTrackers,
  fetchVehiclesTypes,
  fetchBodies,
  fetchAxis,
  fetchFuel,
  fetchImplements,
  fetchAllProvinces,
} from 'utils/fetches';
import { CIVIL_STATUS, CNH_TYPES } from 'v3/utils/masks';
import { colors } from 'v3/pages/Vehicle/shared/controller';

const countriesOptions = [];
const anttTypesRntrcTypesOptions = [];
const paymentMethodsOptions = [];
const trackersOptions = [];
const vehicleTypesOptions = [];
const vehicleBodiesOptions = [];
const vehicleAxisOptions = [];
const fuelOptions = [];
const implementTypesOptions = [];
const provincesOptions = [];

const PROPERTY_TYPES = [
  { label: 'Próprio' },
  { label: 'Agregado' },
  { label: 'Terceiro' },
];

const PROPERTY_STATUS = [
  { label: 'Ativo' },
  { label: 'Inativo' },
];

const GENDER_OPTIONS = [
  { label: 'Masculino' },
  { label: 'Feminino' },
];

const REQUEST_TYPE_OPTIONS = [
  { value: 1, label: 'Veículo' },
  { value: 2, label: 'Motorista' },
  { value: 3, label: 'Transportadora' },
];

function processValue(value) {
  const list = Array.isArray(value)
    ? value
    : Array.isArray(value?.data)
    ? value.data
    : Array.isArray(value?.content)
    ? value.content
    : Array.isArray(value?.results)
    ? value.results
    : [];

  return list.map((v) => ({
    id: v?.id ?? v?.value ?? v?.code ?? v?.key ?? String(v),
    label: v?.name ?? v?.label ?? v?.description ?? String(v),
  }));
}

/**
 * Helper para carregar opções e popular o array alvo, com log de erro.
 */
function load(fetchFn, targetArray, name) {
  return fetchFn()
    .then((value) => {
      const processed = processValue(value);
      targetArray.push(...processed);
    })
    .catch((err) => {
      console.error(`[options] Falha ao carregar ${name}:`, err);
    });
}

load(fetchAllProvinces, provincesOptions, 'provinces');
load(fetchImplements, implementTypesOptions, 'implements');
load(fetchFuel, fuelOptions, 'fuel');
load(fetchAxis, vehicleAxisOptions, 'axis');
load(fetchBodies, vehicleBodiesOptions, 'bodies');
load(fetchVehiclesTypes, vehicleTypesOptions, 'vehicle types');
load(fetchTrackers, trackersOptions, 'trackers');
load(fetchPaymentMethods, paymentMethodsOptions, 'payment methods');
load(fetchAnttTypes, anttTypesRntrcTypesOptions, 'antt types');
load(fetchCountries, countriesOptions, 'countries');

export const requestTypeOptions = REQUEST_TYPE_OPTIONS;

export const allSelectWithOptionsFields = {
  rntrc_type: {
    options: anttTypesRntrcTypesOptions,
    label: 'Tipo RNTRC',
  },
  country_id: {
    options: countriesOptions,
    label: 'País',
  },
  payment_method: {
    options: paymentMethodsOptions,
    label: 'Método de Pagamento',
  },
  antt_type: {
    options: anttTypesRntrcTypesOptions,
    label: 'Tipo ANTT',
  },
  tracker_id: {
    options: trackersOptions,
    label: 'Rastreador',
  },
  vehicle_type_id: {
    options: vehicleTypesOptions,
    label: 'Tipo de Veículo',
  },
  vehicle_body_type_id: {
    options: vehicleBodiesOptions,
    label: 'Tipo carroceria',
  },
  vehicle_axis_id: {
    options: vehicleAxisOptions,
    label: 'Quantidade de Eixos',
  },
  fuel_id: {
    options: fuelOptions,
    label: 'Combustível',
  },
  color: {
    options: colors,
    label: 'Cor',
  },
  vehicle_implement_type: {
    options: implementTypesOptions,
    label: 'Tipo implemento',
  },
  rg_emissor: {
    options: provincesOptions,
    label: 'UF Emissor',
  },
  province_id: {
    options: provincesOptions,
    label: 'Estado',
  },
  born_province_id: {
    options: provincesOptions,
    label: 'Estado de Nascimento',
  },
  civil_state_id: {
    options: CIVIL_STATUS,
    label: 'Estado Civil',
  },
  civil_status: {
    options: CIVIL_STATUS,
    label: 'Status Civil',
  },
  property_type: {
    options: PROPERTY_TYPES,
    label: 'Tipo Propriedade',
  },
  property_status: {
    options: PROPERTY_STATUS,
    label: 'Status Propriedade',
  },
  cnh_type: {
    options: CNH_TYPES,
    label: 'Tipo CNH',
  },
  gender: {
    options: GENDER_OPTIONS,
    label: 'Gênero',
  },
};

export const allRadioFields = {
  mopp: { label: 'Mopp' },
  exclusive: { label: 'Exclusivo' },
  tracked: { label: 'Monitorado' },
};

export const allSelectAsyncCityFields = {
  city: { label: 'Cidade' },
  born_city_id: { label: 'Cidade de Nascimento' },
  cnh_dispatch_city: { label: 'Cidade de Emissão CNH' },
  plate_city: { label: 'Cidade da Placa' },
};
